import {
	Group,
	Radio,
	Stack,
	UnstyledButton,
	createStyles,
} from '@mantine/core';
import { replaceAmpersandWithAnd } from '@repo/common/utils/stringUtils';
import { Text } from '@repo/foundations';
import { TextInputLabel } from '@repo/foundations/components';
import { capitalize } from 'lodash-es';

const useStyles = createStyles((theme) => ({
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xs,
		padding: theme.spacing.xs,
		border: 'none',
	},

	radio: {
		width: theme.spacing.md,
		height: theme.spacing.md,
		minWidth: theme.spacing.md,
		minHeight: theme.spacing.md,
		strokeWidth: 0.5,
		margin: 0,
	},
}));

interface ConnectionChoiceListProps {
	title: string;
	groups: string[];
	value: string;
	onChange: (value: string) => void;
	disabled?: boolean;
}

function ConnectionChoiceList({
	title,
	groups,
	value,
	onChange,
	disabled,
}: ConnectionChoiceListProps) {
	const { classes } = useStyles();

	return (
		<Radio.Group value={value} onChange={onChange}>
			<TextInputLabel label={title} inputId={title} />
			<Group spacing="0">
				{groups.map((group) => (
					<Stack key={group} style={{ width: '100%' }}>
						<UnstyledButton
							key={group}
							className={classes.wrapper}
							onClick={() => onChange(group)}
							data-active={value === group}
							disabled={disabled}
						>
							<Radio value={group} classNames={{ radio: classes.radio }} />
							<Text size="sm">
								{replaceAmpersandWithAnd(capitalize(group))}
							</Text>
						</UnstyledButton>
					</Stack>
				))}
			</Group>
		</Radio.Group>
	);
}

export default ConnectionChoiceList;
